import { render } from "./TournamentGallery.vue?vue&type=template&id=2582137a&scoped=true"
import script from "./TournamentGallery.vue?vue&type=script&lang=js"
export * from "./TournamentGallery.vue?vue&type=script&lang=js"

import "./TournamentGallery.vue?vue&type=style&index=0&id=2582137a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2582137a"]])

export default __exports__